import { render, staticRenderFns } from "./ClientSkillsConsultantUpdateCpt.vue?vue&type=template&id=254c3eac&scoped=true&"
import script from "./ClientSkillsConsultantUpdateCpt.vue?vue&type=script&lang=ts&"
export * from "./ClientSkillsConsultantUpdateCpt.vue?vue&type=script&lang=ts&"
import style0 from "./ClientSkillsConsultantUpdateCpt.vue?vue&type=style&index=0&id=254c3eac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254c3eac",
  null
  
)

export default component.exports